import React, { useState } from "react";
import axios from "axios";
import { baseurl } from "../../../Baseurl";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../api/axiosInstance";

export default function AddStaff() {
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    firstName: "",
    lastName: "",
    prefix: "",
    dateOfBirth: "",
    licenseId: "",
    civilId: "",
    passport: "",
    gender: "",
    role: "",
    phoneNumber: "",
  });

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email) || email === "";
  };

  const validatePhoneNumber = (phone) => {
    const phoneRegex = /^[0-9]{8,15}$/;
    return phoneRegex.test(phone) || phone === "";
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    let error = "";
    switch (name) {
      case "email":
        if (!validateEmail(value) && value !== "") {
          error = "Enter a valid email address";
        }
        break;
      case "password":
        if (value && value.length < 6) {
          error = "Password must be at least 6 characters";
        }
        break;
      case "phoneNumber":
        if (!validatePhoneNumber(value) && value !== "") {
          error = "Phone number must be 8-15 digits";
        }
        break;
      default:
        break;
    }

    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleFile = (e) => setFile(e.target.files[0] || null);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.prefix) newErrors.prefix = "Prefix is required";
    if (!formData.firstName) newErrors.firstName = "First name is required";
    if (!formData.lastName) newErrors.lastName = "Last name is required";
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!validateEmail(formData.email)) {
      newErrors.email = "Enter a valid email address";
    }
    if (!formData.password) {
      newErrors.password = "Password is required";
    } else if (formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }
    if (!formData.dateOfBirth) newErrors.dateOfBirth = "Date of birth is required";
    if (!formData.gender) newErrors.gender = "Gender is required";
    if (!formData.role) newErrors.role = "Role is required";
    if (!formData.phoneNumber) {
      newErrors.phoneNumber = "Phone number is required";
    } else if (!validatePhoneNumber(formData.phoneNumber)) {
      newErrors.phoneNumber = "Phone number must be 8-15 digits";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      Swal.fire("Validation Error", "Please correct the errors in the form", "error");
      return;
    }

    try {
      const data = new FormData();
      data.append("email", formData.email);
      data.append("password", formData.password);
      data.append("role", formData.role);
      data.append("fullName", formData.firstName);
      data.append("shortName", formData.lastName);
      data.append("prefix", formData.prefix);
      data.append("dateOfBirth", formData.dateOfBirth);
      data.append("licenseId", formData.licenseId);
      data.append("civilId", formData.civilId);
      data.append("phoneNumber", formData.phoneNumber);
      data.append("passport", formData.passport);
      data.append("gender", formData.gender);
      if (file) data.append("personalPhoto", file);

      const res = await axiosInstance.post(`addDoctorDetails`, data, { headers: { "Content-Type": "multipart/form-data" } });
      if (res.data.success) {
        Swal.fire("Success", "Staff added successfully", "success");
        navigate("/Admin/ManageStaff");
      } else {
        Swal.fire("Error", res.data.message || "Failed to add staff", "error");
      }
    } catch (err) {
      const backendMessage =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err.message ||
        "Something went wrong";

      Swal.fire("Error", backendMessage, "error");
    }
  };

  return (
    <div className="pc-container">
      <div className="pc-content">
        <div className="col-12">
          <div className="card table-card">
            <div className="tableHeader">
              <h5 style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ cursor: 'pointer', color: '#3f75c7', fontWeight: 'bold', fontSize: '1.5rem' }} onClick={() => navigate(-1)} title="Back">&larr;</span>
                Add Staff
              </h5>
            </div>
            <form onSubmit={handleSubmit} autoComplete="off" className="row g-3 px-3 py-2 mb-3">
              <div className="col-md-6">
                <label className="form-label">Prefix</label>
                <select
                  name="prefix"
                  className={`form-control ${errors.prefix ? "is-invalid" : ""}`}
                  value={formData.prefix}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="Dr.">Dr.</option>
                  <option value="Mr.">Mr.</option>
                  <option value="Mrs.">Mrs.</option>
                  <option value="Miss">Miss</option>
                </select>
                {errors.prefix && <div className="text-danger small">{errors.prefix}</div>}
              </div>
              {[
                ["firstName", "text", "First Name"],
                ["lastName", "text", "Last Name"],
                ["email", "email", "Email"],
                ["dateOfBirth", "date", "Date of Birth"],
                ["licenseId", "text", "License ID"],
                ["civilId", "text", "Civil ID"],
                ["passport", "text", "Passport"],
                ["phoneNumber", "text", "Phone Number"],
              ].map(([name, type, label]) => (
                <div className="col-md-6" key={name}>
                  <label className="form-label">{label}</label>
                  <input
                    type={type}
                    name={name}
                    className={`form-control ${errors[name] ? "is-invalid" : ""}`}
                    value={formData[name]}
                    onChange={handleChange}
                    autoComplete="off"
                  />
                  {errors[name] && <div className="text-danger small">{errors[name]}</div>}
                </div>
              ))}

              <div className="col-md-6">
                <label className="form-label">Password</label>
                <div className="position-relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    className={`form-control ${errors.password ? "is-invalid" : ""}`}
                    value={formData.password}
                    onChange={handleChange}
                    autoComplete="new-password"
                  />
                  <i
                    className={`ti ${showPassword ? "ti-eye-off" : "ti-eye"}`}
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      fontSize: "18px",
                    }}
                  ></i>
                </div>
                {errors.password && <div className="text-danger small">{errors.password}</div>}
              </div>



              <div className="col-md-6">
                <label className="form-label">Gender</label>
                <select
                  name="gender"
                  className={`form-control ${errors.gender ? "is-invalid" : ""}`}
                  value={formData.gender}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
                {errors.gender && <div className="text-danger small">{errors.gender}</div>}
              </div>
              <div className="col-md-6">
                <label className="form-label">Role</label>
                <select
                  name="role"
                  className={`form-control ${errors.role ? "is-invalid" : ""}`}
                  value={formData.role}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="admin">Admin</option>
                  <option value="receptionist">Receptionist</option>
                </select>
                {errors.role && <div className="text-danger small">{errors.role}</div>}
              </div>
              <div className="col-md-6">
                <label className="form-label">Photo</label>
                <input type="file" className="form-control" onChange={handleFile} />
              </div>
              <div className="col-12 text-center mb-3">
                <button type="submit" className="bgBtn">Add Staff</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
